import {
  EsigRequestNotification,
  EsigRequestCompleteNotification,
  NotificationsState,
} from '../../store/notifications/types';
import { ChannelOptionData } from '../Channels/ChannelSidebarItem';

/**
 *
 * @param notificationsState contains all notifications loaded into state
 * @returns sorted channel options based on lastNotification, which should always be present on options using this sort function
 */
export const channelOptionsSortFunction = (
  notificationsState: NotificationsState,
) => (a: ChannelOptionData, b: ChannelOptionData) => {
  let esigNotificationA:
    | EsigRequestNotification
    | EsigRequestCompleteNotification
    | undefined;
  let esigNotificationB:
    | EsigRequestNotification
    | EsigRequestCompleteNotification
    | undefined;

  [
    ...notificationsState.esigRequestNotifications,
    ...notificationsState.esigRequestCompleteNotifications,
  ].forEach(esigNotif => {
    // esig notifications are not set as lastNotification and if they match a channel they overwrite other notifications set
    if (a.fileChannel?.id === esigNotif.fields.channelId) {
      esigNotificationA = esigNotif;
    }
    if (b.fileChannel?.id === esigNotif.fields.channelId) {
      esigNotificationB = esigNotif;
    }
  });

  // first we see if esig notifications (which do not appear in lastNotification) exist, for sorting
  // we then get the "last activity" of A and B, defined by the lastNotification updated date (if it exists), otherwise created date
  const lastNotifA =
    esigNotificationA || a.fileChannel?.fields.lastNotification;
  const lastActivityDateA = lastNotifA
    ? lastNotifA.updatedDate
    : a.fileChannel?.createdDate;

  const lastNotifB =
    esigNotificationB || b.fileChannel?.fields.lastNotification;
  const lastActivityDateB = lastNotifB
    ? lastNotifB.updatedDate
    : b.fileChannel?.createdDate;
  if (lastActivityDateA && lastActivityDateB) {
    return lastActivityDateA > lastActivityDateB ? -1 : 1;
  }
  return 0;
};
